import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultEvents = {
    onSettingsChange: noop,
    onClose: noop,
    onOpen: noop,
    onSecondaryActionClick: noop
};

function useDetailsModalEvents(props) {
    const {
        detailsModalEvents: propsEvents
    } = props;

    const {
        events
    } = useEvents(defaultEvents, propsEvents);

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useDetailsModalEvents};
